import { render, staticRenderFns } from "./Ordre.vue?vue&type=template&id=4bae21b9&scoped=true&"
import script from "./Ordre.vue?vue&type=script&lang=js&"
export * from "./Ordre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae21b9",
  null
  
)

export default component.exports